import styled from "styled-components";

export const RowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 3rem;
`;

export const Title = styled.h1`
	font-size: 30px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const MessageContainer = styled.div`
	display: flex;
	width: 536px;
	height: 81px;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 3rem;
`;

export const MessageTitle = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: #31475a;
`;

export const MessageText = styled.div`
	text-align: center;
	font-size: 16px;
	color: #31475a;
	line-height: 1.3;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	margin-bottom: 2rem;
`;

export const Button = styled.button`
	width: 289px;
	height: 39px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	background-color: ${props => (props.primary ? "#534B99" : "white")};
	border: ${props => (props.primary ? "none" : "1px solid #534B99")};
	border-radius: 8px;
	padding: 8px 32px;

	div {
		color: #fff;
		font-weight: 700;
	}
`;

export const StepButton = styled.button`
	width: 124px;
	height: 39px;
	background-color: ${props => (props.primary ? "#534B99" : "white")};
	color: ${props => (props.primary ? "white" : "#534B99")};
	border: ${props => (props.primary ? "none" : "1px solid #534B99")};
	border-radius: 8px;
	padding: 8px 32px;
	font-weight: 700;
`;

export const InstructionsContainer = styled.div`
	display: flex;
	width: 536px;
	height: 152px;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 3rem;
	background-color: #eef2ff;
	border: 1px solid #a3b3ff;
	border-radius: 16px;
	padding: 16px 32px;
`;

export const InstructionsTitle = styled.div`
	font-weight: 700;
	color: #31475a;
`;

export const InstructionsItemList = styled.ul`
	margin-left: 1rem;
`;

export const InstructionsItem = styled.li`
	color: #31475a;
`;
